import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { ProjectExtended } from "@nova/schemas"
import { useClusteredMarkers } from "features/map/useClusteredMarkers"
import { getProjectFilterOptionById } from "features/overview/filters/projectFilterOptions"
import { selectProjectFilter } from "features/overview/slice"
import { useAppSelector } from "integrations/redux/hooks"
import { useMemo } from "react"
import useSWR from "swr"

export const useGeolocatedProjects = ({
    orgId,
    filtered = true,
}: {
    orgId: string | undefined
    filtered?: boolean
}) => {
    const projectFilterId = useAppSelector(selectProjectFilter)
    const projectFilter = getProjectFilterOptionById(projectFilterId)
    const swr = useSWR(
        orgId ? ["geolocated-projects", orgId] : null,
        () => {
            return fetchApiGateway("get /org/:orgId/geolocated-projects", {
                params: { orgId: orgId! },
            })
        },
        { revalidateOnFocus: false }
    )
    const data = useMemo(() => {
        if (!filtered) {
            return swr.data ?? { geolocatedProjects: [], nonGeolocatedProjects: [] }
        }
        return {
            geolocatedProjects: (swr.data?.geolocatedProjects ?? []).filter(projectFilter.filter),
            nonGeolocatedProjects: (swr.data?.nonGeolocatedProjects ?? []).filter(
                projectFilter.filter
            ),
        }
    }, [swr.data, filtered, projectFilter.filter])
    return { ...swr, data }
}

const getPosition = (project: ProjectExtended) =>
    [project.location!.longitude, project.location!.latitude] as [number, number]
const getKey = (project: ProjectExtended) => project.id
export const useClusteredGeolocatedProjects = ({
    orgId,
    filtered = true,
}: {
    orgId: string | undefined
    filtered?: boolean
}) => {
    const {
        data: { geolocatedProjects },
    } = useGeolocatedProjects({ orgId, filtered })
    return useClusteredMarkers({ items: geolocatedProjects, getPosition, getKey, radiusPx: 80 })
}
